import React, { Component } from 'react';
import './Success.css';
export class Success extends Component {
   
    render() {
        return (
            <div className="mainbody">
                <div className="cards">
                    <div style={{ borderRadius: '200px', height: '200px', width: '200px', background: '#F8FAF5', margin: '0 auto' }}>
                        <i style={{ color: '#88B04B' }} className="checkmark">✓</i>
                    </div>
                    <h1 style={{ color: '#88B04B' }}>Success</h1>
                    <p>We received your success request;<br /> we'll be in touch shortly!</p>
                </div>
            </div>
        );
    }
}    